module.exports = __webpack_public_path__ + "img/my.c39c0615.png";